import { defineComponent as h, useModel as f, computed as o, openBlock as b, createElementBlock as x, normalizeClass as i, createElementVNode as t, mergeModels as m } from "vue";
const v = ["checked", "disabled"], w = /* @__PURE__ */ h({
  __name: "BaseSwitch",
  props: /* @__PURE__ */ m({
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(n) {
    const l = n, s = f(n, "modelValue"), u = o(() => {
      const e = [
        "base-switch",
        "relative inline-flex transition-all duration-200",
        "focus:outline-none"
      ];
      return l.size === "sm" ? e.push("w-[34px] h-[20px]") : e.push("w-[50px] h-[24px]"), l.disabled && e.push("base-switch--disabled"), e.join(" ");
    }), d = o(() => {
      const e = [
        "base-switch__background",
        "absolute inset-0 rounded-full transition-all duration-200"
      ];
      return s.value ? e.push("base-switch__background--on") : e.push("base-switch__background--off"), e.join(" ");
    }), c = o(() => {
      const e = ["base-switch__thumb", "absolute rounded-full transition-all duration-200"];
      return l.size === "sm" ? (e.push("w-[14px] h-[14px] top-[3px]"), s.value ? e.push("translate-x-[17px]") : e.push("translate-x-[3px]")) : (e.push("w-[20px] h-[20px] top-[2px]"), s.value ? e.push("translate-x-[28px]") : e.push("translate-x-[2px]")), e.join(" ");
    }), p = () => {
      l.disabled || (s.value = !s.value);
    }, r = (e) => {
      if (!l.disabled) {
        const a = e.target;
        a && (s.value = a.checked);
      }
    };
    return (e, a) => (b(), x("div", {
      class: i(u.value),
      onClick: p
    }, [
      t("input", {
        type: "checkbox",
        checked: s.value,
        disabled: n.disabled,
        class: "sr-only",
        onChange: r
      }, null, 40, v),
      t("div", {
        class: i(d.value)
      }, null, 2),
      t("div", {
        class: i(c.value)
      }, null, 2),
      a[0] || (a[0] = t("span", { class: "sr-only" }, "Toggle switch", -1))
    ], 2));
  }
});
export {
  w as default
};
